import { FocusEventHandler, ReactNode } from 'react';
import { Select } from 'antd';
import './style.scss';
import { FilterFunc } from 'rc-select/lib/Select';

export const { Option } = Select;

type Props = {
  value?: any;
  children: ReactNode;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (value: string, option: any) => void;
  onBlur?: FocusEventHandler<HTMLElement> | undefined;
  filterOption?: boolean | FilterFunc<any>;
  filterSort?: (optionA: any, optionB: any) => number;
  onPopupScroll?: React.UIEventHandler<HTMLDivElement>;
  onSearch?: (value: string) => void;
  onDropdownVisibleChange?: (open?: boolean) => void;
};
export const SelectWithFilter = ({
  value = '',
  placeholder,
  disabled = false,
  children,
  onChange,
  onBlur,
  onPopupScroll,
  onSearch,
  onDropdownVisibleChange,
}: Props) => {
  return (
    <div className="tru-single-select-arrow-wrapper">
      <Select
        disabled={disabled}
        showSearch
        filterOption={false}
        onChange={onChange}
        onBlur={onBlur}
        style={{ width: 272 }}
        value={value}
        placeholder={placeholder}
        onPopupScroll={onPopupScroll}
        onSearch={onSearch}
        onDropdownVisibleChange={(open) => {
          onDropdownVisibleChange?.(open)
        }}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
      >
        {children}
      </Select>
    </div>
  );
};
